
























































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import InfoRow from '@/views/AiiTasks/InfoRow.vue'
import feeRow from './feeRow.vue'
import injuredFeeItem from './injuredFeeItem.vue'
import dependentFeeItem from './dependentFeeItem.vue'
import cloneDeep from 'lodash/cloneDeep'
import { add, bignumber, subtract, multiply } from 'mathjs'
import { zeroUnit } from '@/web-task/utils'
import { hasValue } from '@/utils/util'

const feeOrder: Array<string> = [
	'currentMedicalFee',
	'furtherMedicalFee',
	'nutritionFee',
	'plasticFee',
	'mealFee',
	'fareFee',
	'liveFee',
	'absentFee',
	'recoveryFee',
	'careFee',
	'deviceFee',
	'metalFee',
	'funeralFee',
	'deadFee',
	'carstuffFee',
	'suspensionFee',
	'otherFee',
]

@Component({
	components: {
		InfoRow,
		feeRow,
		injuredFeeItem,
		dependentFeeItem,
	},
})
export default class FeeTable extends Vue {
	private form: any = {}
	// 是否有抚养费项
	private hasFuYang = false
	private spans: any = {
		title: 4,
		formula: 6,
		compulsory: 4,
		commercial: 4,
		remark: 6,
	}
	private feeList: any = []
	private careFeeList: any = []
	private injuredFee: any = null
	private dependentFee: any = []
	// 护理费careFee、伤残赔偿金injuredFee、被扶养人赔偿金dependentFee
	private cid: number = 0
	private iid: number = 0
	private did: number = 0

	@Prop({ default: false })
	private isReadonly!: boolean

	@Prop({ default: () => ({}) })
	private initialPlan!: any

	@Prop()
	private order!: any

	private get isHuman() {
		if (this.order.includeFormType) {
			// 人伤/人车混合
			return ['01', '03'].includes(this.order.includeFormType)
		} else {
			// 默认展示所有项
			return true
		}
	}

	private get isCar() {
		if (this.order.includeFormType) {
			// 车物/人车混合
			return ['02', '03'].includes(this.order.includeFormType)
		} else {
			// 默认展示所有项
			return true
		}
	}

	private get isDead() {
		// 是否涉及死亡
		return this.order.death ? this.order.death === '1' : true
	}

	private get sumInfo() {
		return [
			{
				label: '交强险定损总金额',
				value: zeroUnit(
					this.initialPlan && this.initialPlan.compulsorySum,
					'元'
				),
				slot: 'compulsorySum',
			},
			{
				label: '商业险定损总金额',
				value: zeroUnit(
					this.initialPlan && this.initialPlan.commercialSum,
					'元'
				),
				slot: 'commercialSum',
			},
			{
				label: '备注',
				value: this.initialPlan && this.initialPlan.remark,
			},
		]
	}

	private get sumSpan() {
		return {
			交强险定损总金额: 8,
			商业险定损总金额: 8,
			备注: 16,
		}
	}

	private get configMap(): any {
		return {
			currentMedicalFee: {
				title: '医疗费（实际产生）',
				name: 'currentMedicalFee',
				show: this.isHuman,
			},
			furtherMedicalFee: {
				title: '医疗费（后续医疗）',
				name: 'furtherMedicalFee',
				show: this.isHuman,
			},
			nutritionFee: {
				title: '必要营养费',
				name: 'nutritionFee',
				show: this.isHuman,
			},
			plasticFee: {
				title: '整容费',
				name: 'plasticFee',
				show: this.isHuman,
			},
			mealFee: {
				title: '住院伙食补助费',
				name: 'mealFee',
				show: this.isHuman,
				formula: true,
			},
			fareFee: {
				title: '就医期间交通费',
				name: 'fareFee',
				show: this.isHuman,
			},
			liveFee: {
				title: '住宿费',
				name: 'liveFee',
				show: this.isHuman,
			},
			absentFee: {
				title: '误工费',
				name: 'absentFee',
				show: this.isHuman,
				formula: true,
			},
			recoveryFee: {
				title: '康复费',
				name: 'recoveryFee',
				show: this.isHuman,
			},
			careFee: {
				title: '护理费',
				name: 'careFee',
				show: this.isHuman,
				formula: true,
				hasRatio: true,
				careFeeAdd: {
					title: '新增',
					callback: (index: number) => {
						const careFeeIndex = this.form.getFieldValue('careFeeIndex')
						if (careFeeIndex.length >= 10) {
							this.$message.warning('护理费最多10个')
							return
						}
						const nextCareFeeIndex = careFeeIndex.concat(++this.cid)
						this.form.setFieldsValue({
							careFeeIndex: nextCareFeeIndex,
						})
					},
				},
				careFeeCut: {
					title: '删除',
					callback: (key: number) => {
						let careFeeIndex = this.form.getFieldValue('careFeeIndex')
						this.form.setFieldsValue({
							careFeeIndex: careFeeIndex.filter((item: number) => {
								return item !== key
							}),
						})
						this.$nextTick(() => {
							this.commercialChange()
							this.compulsoryChange()
						})
					},
				},
			},
			deviceFee: {
				title: '残疾辅助器具费',
				name: 'deviceFee',
				show: this.isHuman,
			},
			metalFee: {
				title: '精神抚慰金',
				name: 'metalFee',
				show: this.isHuman,
			},
			funeralFee: {
				title: '丧葬费',
				name: 'funeralFee',
				show: this.isDead,
			},
			deadFee: {
				title: '死亡赔偿金',
				name: 'deadFee',
				show: this.isDead,
			},
			carstuffFee: {
				title: '车/物金额',
				name: 'carstuffFee',
				show: this.isCar,
			},
			suspensionFee: {
				title: '停运损失金额',
				name: 'suspensionFee',
				show: this.isCar,
			},
			otherFee: {
				title: '其他',
				name: 'otherFee',
				show: true,
			},
			injuredFee: {
				title: '伤残赔偿金',
				name: 'injuredFee',
				show: this.isHuman,
				formula: true,
				hasRatio: true,
			},
			dependentFee: {
				title: '被抚养人赔偿金',
				name: 'dependentFee',
				show: this.isHuman,
				formula: true,
				hasRatio: true,
			},
		}
	}

	@Watch('initialPlan', { immediate: true })
	private onInitialChange() {
		this.reset()

		let bigList: any = (this.initialPlan && this.initialPlan.schemeList) || []
		let bigMap: any = {}
		bigList.forEach((item: any) => {
			if (!bigMap[item.itemType]) {
				bigMap[item.itemType] = []
			}
			bigMap[item.itemType].push(item)
		})
		// 费用项
		feeOrder.forEach((itemType: string, index: number) => {
			if (itemType === 'careFee') {
				if (bigMap[itemType] || !this.isReadonly) {
					// 标志位
					this.feeList.push({
						itemType: itemType,
					})
				}
			} else if (bigMap[itemType]) {
				this.feeList.push(...bigMap[itemType])
			} else if (!this.isReadonly) {
				this.feeList.push({
					itemType: itemType,
				})
			}
		})
		this.careFeeList = bigMap['careFee'] || []
		this.injuredFee = (bigMap['injuredFee'] && bigMap['injuredFee'][0]) || {}
		this.dependentFee = bigMap['dependentFee'] || []
		let defaultNum = this.isReadonly ? 0 : 1
		// 编辑/新增应诉方案 仍展示无原始值项
		this.iid =
			(this.injuredFee &&
				this.injuredFee.disabilityList &&
				this.injuredFee.disabilityList.length) ||
			defaultNum
		this.cid = this.careFeeList.length || defaultNum
		this.did = this.dependentFee.length || defaultNum
		this.$nextTick(() => {
			let sumField = this.isReadonly
				? {}
				: {
						compulsorySum: this.initialPlan && this.initialPlan.compulsorySum,
						commercialSum: this.initialPlan && this.initialPlan.commercialSum,
						compensationSum:
							this.initialPlan && this.initialPlan.compensationSum,
				  }
			let field = {
				careFeeIndex: this.getInitialArr(this.cid),
				dependentFeeIndex: this.getInitialArr(this.did),
				injuredFeeIndex: this.getInitialArr(this.iid),
				...sumField,
			}
			this.form.setFieldsValue(field)
		})
	}

	private getInitialArr(len: number) {
		let indexArr: Array<number> = []
		for (let i = 0; i < len; i++) {
			indexArr.push(i)
		}
		return indexArr
	}

	private reset() {
		this.feeList = []
		this.dependentFee = []
		this.injuredFee = null
		this.cid = 0
		this.did = 0
		this.iid = 0
		// this.form.setFieldsValue({
		// 	careFeeIndex: [],
		// 	dependentFeeIndex: [],
		// 	injuredFeeIndex: [],
		// })
	}

	private addFormItem(
		fieldName: string,
		counter: number,
		maximum: number,
		errMsg: string
	) {
		const keys = this.form.getFieldValue(fieldName)
		if (keys.length >= maximum) {
			this.$message.warning(errMsg)
			return
		}
		const nextKeys = keys.concat(counter++)
		this.form.setFieldsValue({
			[`${fieldName}`]: nextKeys,
		})
		return counter
	}

	private removeFormItem(fieldName: string, key: number) {
		let keys = this.form.getFieldValue(fieldName)
		this.form.setFieldsValue({
			[`${fieldName}`]: keys.filter((item: number) => {
				return item !== key
			}),
		})
	}

	private addDependent() {
		this.did = this.addFormItem(
			'dependentFeeIndex',
			this.did,
			20,
			'被抚养人赔偿金最多20个'
		) as number
	}

	private removeDependent(key: number) {
		this.removeFormItem('dependentFeeIndex', key)
		this.$nextTick(() => {
			this.commercialChange()
			this.compulsoryChange()
		})
	}

	private addInjured() {
		this.iid = this.addFormItem(
			'injuredFeeIndex',
			this.iid,
			50,
			'伤残部位最多50个'
		) as number
	}

	private removeInjured(key: number) {
		this.removeFormItem('injuredFeeIndex', key)
	}

	private sumFloat(sum: any, augend: string) {
		let reg = /^\d+(\.\d+)?$/
		if (reg.test(augend)) {
			if (!sum) {
				sum = bignumber(0)
			}
			sum = add(sum, bignumber(augend))
		}
		return sum
	}

	private commercialChange() {
		let sum: any = null
		// 费用项表格商业险小计总和
		this.feeList.forEach((item: any) => {
			let currentConfig = this.configMap[item.itemType]
			if (currentConfig.show) {
				if (item.itemType !== 'careFee') {
					sum = this.sumFloat(
						sum,
						this.form.getFieldValue(`${currentConfig.name}.commercial`)
					)
				} else {
					this.form.getFieldValue('careFeeIndex').forEach((k: number) => {
						sum = this.sumFloat(
							sum,
							this.form.getFieldValue(`${currentConfig.name}[${k}].commercial`)
						)
					})
				}
			}
		})
		// 伤残赔偿金
		sum = this.sumFloat(sum, this.form.getFieldValue('injuredFee.commercial'))
		// 被抚养人赔偿金
		this.form.getFieldValue('dependentFeeIndex').forEach((k: number) => {
			sum = this.sumFloat(
				sum,
				this.form.getFieldValue(`dependentFee[${k}].commercial`)
			)
		})
		// let total = this.sumFloat(sum, this.form.getFieldValue('compulsorySum'))

		this.form.setFieldsValue({
			commercialSum: sum && sum.valueOf(),
			// compensationSum: total && total.valueOf(),
		})
	}

	private compulsoryChange() {
		let sum: any = null
		// 费用项表格交强险小计总和
		this.feeList.forEach((item: any) => {
			let currentConfig = this.configMap[item.itemType]
			if (currentConfig.show) {
				if (item.itemType !== 'careFee') {
					sum = this.sumFloat(
						sum,
						this.form.getFieldValue(`${currentConfig.name}.compulsory`)
					)
				} else {
					this.form.getFieldValue('careFeeIndex').forEach((k: number) => {
						sum = this.sumFloat(
							sum,
							this.form.getFieldValue(`${currentConfig.name}[${k}].compulsory`)
						)
					})
				}
			}
		})
		// 伤残赔偿金
		sum = this.sumFloat(sum, this.form.getFieldValue('injuredFee.compulsory'))
		// 被抚养人赔偿金
		this.form.getFieldValue('dependentFeeIndex').forEach((k: number) => {
			sum = this.sumFloat(
				sum,
				this.form.getFieldValue(`dependentFee[${k}].compulsory`)
			)
		})
		// let total = this.sumFloat(sum, this.form.getFieldValue('commercialSum'))

		this.form.setFieldsValue({
			compulsorySum: sum && sum.valueOf(),
			// compensationSum: total && total.valueOf(),
		})
	}

	private onCancel() {
		this.$emit('handleCancel')
	}

	// 过滤费用项空值项
	private emptyFilter(current: any, itemType: string) {
		let res: any = []
		if (Array.isArray(current)) {
			current.forEach((item: any) => {
				let temp = this.emptyFilter(item, itemType)
				res.push(...temp)
			})
		} else {
			let hasValueKey: string | undefined = Object.keys(current).find(
				(key: string) => {
					if (typeof current[key] !== 'object') {
						return hasValue(current[key])
					} else {
						return false
					}
				}
			)
			// 过滤disabilityList中的空项
			if (current.disabilityList) {
				current.disabilityList = this.emptyFilter(
					current.disabilityList,
					itemType
				)
				current.disabilityList = current.disabilityList.map((item: any) => {
					return Object.assign({}, item, {
						assessItem: item.assessItem && item.assessItem.label,
					})
				})
			}
			if (hasValueKey) {
				res.push(
					Object.assign({}, current, {
						itemType: itemType,
						itemName: this.configMap[itemType].title,
					})
				)
			} else {
				if (current.familyInfo) {
					let temp = this.emptyFilter(current.familyInfo, itemType)
					if (temp && temp.length) {
						res.push(
							Object.assign({}, current, {
								itemType: itemType,
								itemName: this.configMap[itemType].title,
							})
						)
					}
				} else if (current.disabilityList && current.disabilityList.length) {
					res.push(
						Object.assign({}, current, {
							itemType: itemType,
							itemName: this.configMap[itemType].title,
						})
					)
				}
			}
		}
		return res
	}

	private onSubmit() {
		this.form.validateFieldsAndScroll((err: any, values: any) => {
			if (!err) {
				let feeArr: any = []
				feeOrder
					.concat(['injuredFee', 'dependentFee'])
					.forEach((itemType: string) => {
						let currentItem = values[itemType]
						if (currentItem) {
							let filtered = this.emptyFilter(currentItem, itemType)
							feeArr.push(...filtered)
						}
					})

				if (this.configMap.injuredFee.show) {
					if (
						hasValue(values.injuredFee.commercial) &&
						values.injuredFee.disabilityList.length === 0
					) {
						this.$message.error('请填写伤残部位')
						return
					}
				}
				if (!(values.compensationSum > 0)) {
					this.$message.error('应诉方案赔付总金额不可为0')
					return
				}
				if (!(feeArr && feeArr.length)) {
					this.$message.error('至少需要填写一个非零费用项')
					return
				}
				let data: any = {
					compensationSum: values.compensationSum,
					compulsorySum: values.compulsorySum,
					commercialSum: values.commercialSum,
					remark: values.remark,
					schemeList: feeArr,
				}
				this.$emit('handleSubmit', data)
			}
		})
	}

	private created() {
		this.form = this.$form.createForm(this)
		this.form.getFieldDecorator('careFeeIndex', {
			initialValue: [],
			preserve: true,
		})
		this.form.getFieldDecorator('dependentFeeIndex', {
			initialValue: [],
			preserve: true,
		})
		this.form.getFieldDecorator('injuredFeeIndex', {
			initialValue: [],
			preserve: true,
		})
	}
}
